module.exports = __webpack_public_path__ + "static/img/tongxuan.c091028.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/medicines/tongxuan.jpg
// module id = 60uR
// module chunks = 1